import React from "react";
import Breadcrumb from "../../components/Breadcrumb";
import Membership from "../../components/MembershipPlan/MembershipPlan";


const MembershipPage = () => {
  return (
    <>



        {/* Breadcrumb */}
        

        {/* UsersListLayer */}
        <Membership/>


    </>
  );
};

export default MembershipPage; 